import React from 'react';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import { Breadcrumbs } from './components/Breadcrumbs';
import breadcrumbs from 'images/breadcrumbs.svg';
import UserProfileDropdown from './components/UserProfileDropdown';
import LanguagePicker from 'components/LanguagePickerNew/LanguagePicker';
import style from './index.module.scss';

interface IProps {
	hideNav?: boolean;
	hideProfile?: boolean;
}

const homeLinkDisabledPaths = ['/home', '/', '/password-reset', '/create-new-password'];

const Header: React.FC<IProps> = ({ hideNav, hideProfile }) => {
	const { pathname: currentPath } = useLocation();
	const isHomeLinkDisabled = homeLinkDisabledPaths.includes(currentPath);

	return (
		<header className={style.header} data-test="Header">
			<div className={style.container}>
				<div className={style.wrapperBreadcrumbs} data-test="home">
					<Link to="/home" className={isHomeLinkDisabled ? 'link-disabled' : ''}>
						<svg className={style.iconLogo}>
							<use xlinkHref={`${breadcrumbs}#katemedia`} />
						</svg>
					</Link>
				</div>
				{!hideNav ? <Breadcrumbs path={currentPath} /> : null}
			</div>
			<div className={style.wrapperBreadcrumbs}>
				<LanguagePicker />
				{!hideProfile ? <UserProfileDropdown /> : null}
			</div>
		</header>
	);
};

export default Header;
